import { render, staticRenderFns } from "./BaseLdvButton.vue?vue&type=template&id=c03045f4"
import script from "./BaseLdvButton.vue?vue&type=script&lang=js"
export * from "./BaseLdvButton.vue?vue&type=script&lang=js"
import style0 from "./BaseLdvButton.vue?vue&type=style&index=0&id=c03045f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./BaseLdvButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports